export default __webpack_public_path__ + "static/media/escalera2.0c31f567.png";